import * as React from "react";
import { BellRing, Database, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const features = [{
  title: "Tid Spart",
  description: "Automatiser repeterende oppgaver og frigjør verdifull tid til kundemøter og verdivurderinger.",
  icon: BellRing,
  colorClass: "text-primary bg-primary/10"
}, {
  title: "Økt Salg",
  description: "Bruk AI-drevet innsikt for å identifisere de beste prospektene og konvertere flere leads til salg.",
  icon: ShieldCheck,
  colorClass: "text-chart-2 bg-chart-2/10"
}, {
  title: "Bedre Kundereise",
  description: "Lever personlig oppfølging døgnet rundt med intelligente roboter som forstår meglerbransjen.",
  icon: Database,
  colorClass: "text-chart-3 bg-chart-3/10"
}];
export default function PortalBenefits() {
  return <section data-section-id="221916" id="hvorfor-velge-xora" className="w-full bg-background text-foreground py-12 md:py-16 lg:py-20">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 border-l-4 border-primary pl-6">
          <h2 className="font-default text-3xl font-bold tracking-tight md:text-4xl">
            Hvorfor velge Xora?
          </h2>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {features.map((feature, i) => <Card key={i} data-index={i} className="border-white/10 bg-card/40 shadow-sm backdrop-blur-md transition-all duration-300 hover:shadow-primary/20 hover:shadow-lg rounded-3xl dark:bg-black/40 group">
              <CardHeader className="pb-4">
                <div className={`mb-4 flex size-12 items-center justify-center rounded-xl transition-transform duration-500 group-hover:scale-110 ${feature.colorClass}`}>
                  <feature.icon className="size-6 text-primary" />
                </div>
                <CardTitle className="font-default text-xl font-bold text-foreground">
                  {feature.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="font-default text-muted-foreground leading-relaxed text-base">
                  {feature.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}